module.exports = __webpack_public_path__ + "static/img/tcg-tl.24bd8f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tcg-tl.png
// module id = FOHU
// module chunks = 1